import { dashboardSummarySchema } from '@acasa/shared'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api'

/**
 * One request for the whole Übersicht. Counted in SQL, so this stays cheap
 * enough to be the landing page — unlike the checklist overview, which ships
 * the entire matrix because the table needs every cell.
 */
export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => apiFetch('/dashboard', dashboardSummarySchema),
    // A sync can finish while somebody is looking at the page.
    refetchInterval: 60_000,
  })
}
